import { render } from "./SelectingIngredientListItem.vue?vue&type=template&id=689db0c8&scoped=true&ts=true"
import script from "./SelectingIngredientListItem.vue?vue&type=script&lang=ts"
export * from "./SelectingIngredientListItem.vue?vue&type=script&lang=ts"

import "./SelectingIngredientListItem.vue?vue&type=style&index=0&id=689db0c8&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-689db0c8"]])

export default __exports__